<template>
  <div class="tag-pills">
    <b-button
      v-for="pill in pills"
      :key="pill.filter + '-' + pill.value"
      class="tag-pill"
      @click="removePill(pill)"
    >
      <span>{{ pill.label }}</span>
      <div class="remove-wrapper">
        <font-awesome-icon :icon="['far','times']" />
      </div>
    </b-button>
  </div>
</template>

<script>
import {
  isArray,
  find,
} from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import { FILTER_SIDEBAR_SECTION_KEYS } from '@/constants'

export default {
  name: 'TagPills',

  computed: {
    ...mapGetters('filter', [
      'selectedFilters',
      'dynamicFilterSections',
    ]),

    optionLookup() {
      if (!this.dynamicFilterSections) return {}
      const lookup = {}
      const keys = [...FILTER_SIDEBAR_SECTION_KEYS, 'basic']
      keys.forEach((key) => {
        const section = this.dynamicFilterSections[key]
        if (section && section.options) {
          section.options.forEach((option) => {
            lookup[option.value] = {
              label: option.label,
              displayType: section.display_type,
            }
          })
        }
      })
      return lookup
    },

    pillFilterKeys() {
      const keys = new Set(['tags', 'basic'])
      if (this.dynamicFilterSections) {
        const sectionKeys = [...FILTER_SIDEBAR_SECTION_KEYS, 'basic']
        sectionKeys.forEach((key) => {
          const section = this.dynamicFilterSections[key]
          if (section && section.filter) {
            keys.add(section.filter)
          }
        })
      }
      return [...keys]
    },

    pills() {
      if (!this.dynamicFilterSections) return []

      const pills = []

      this.pillFilterKeys.forEach((filterKey) => {
        const selectedEntry = find(this.selectedFilters, ['filter', filterKey])
        if (!selectedEntry || !selectedEntry.options) return

        const selectedValues = isArray(selectedEntry.options)
          ? selectedEntry.options
          : [selectedEntry.options]

        selectedValues.forEach((value) => {
          const option = this.optionLookup[value]
          if (option) {
            pills.push({
              filter: filterKey,
              value,
              label: option.label,
              displayType: option.displayType,
            })
          }
        })
      })

      return pills
    },
  },

  methods: {
    ...mapActions('filter', [
      'addFilter',
    ]),

    removePill(pill) {
      this.addFilter({ filter: pill.filter, type: pill.displayType, options: [pill.value] })
    },
  },
}
</script>

<style lang="scss">
.tag-pills {
  display: flex;
  gap: 11px;

  .tag-pill {
    border-radius: 4px;
    border: 1px solid rgba(28, 36, 51, 0.20);
    background: $color-search-section-bg;
    width: max-content;
    display: flex;

    .remove-wrapper {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-left: 11px;
    }
  }
}
</style>
